export default __webpack_public_path__ + "static/media/openxLoginFlowImg.ba1e7809.svg";